import { IsISO8601, IsOptional } from 'class-validator';

/**
 * "Sposta in archivio": la voce semplice con sotto-voci diventa un ingrediente
 * del tenant e la riga diventa collegata a quello, in un'unica transazione.
 * `expectedUpdatedAt` (dalla risposta dell'ultimo salvataggio, mai dallo stato
 * del form) protegge da una modifica concorrente della scheda: 409.
 */
export class PromoteIngredientComponentDto {
  @IsOptional()
  @IsISO8601({ strict: true })
  expectedUpdatedAt?: string;
}
